import React, { useEffect } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';

import { ChecklistItems } from '../../../api/configurations/checklist/types';
import { DataStorageForm, UserStorageTabs } from '../../../components';
import { Preloader, ToDashboardError } from '../../../components/ui';
import { SHADOW_PROJECT_TYPE } from '../../../constants';
import { useChecklist, useCurrentProject } from '../../../contexts/settings';
import { usePaths } from '../../../routes/routesHelper';
import { RouteParams } from '../../../routes/types';

const UserDataStorage = ({ match, history }: RouteComponentProps): JSX.Element => {
  const { projectId } = match.params as RouteParams;
  const { enableChecklistItem } = useChecklist(projectId);
  const { currentProjectFetching, currentProject, error } = useCurrentProject(projectId);
  const { navigationPath } = usePaths();

  useEffect(() => {
    enableChecklistItem(ChecklistItems.SET_UP_STORAGE);
  }, []);

  useEffect(() => {
    if (currentProject?.type === SHADOW_PROJECT_TYPE) {
      history.push({ pathname: navigationPath(projectId) });
    }
  }, [currentProject]);

  if (currentProjectFetching) {
    return (
      <UserStorageTabs>
        <Preloader />
      </UserStorageTabs>
    );
  }

  if (error) {
    return <ToDashboardError error={error} pageName="user-data-storage_open" />;
  }

  return (
    <UserStorageTabs>
      <DataStorageForm />
    </UserStorageTabs>
  );
};

export default withRouter(UserDataStorage);
